import React from "react";
import { useNavigate } from "react-router-dom";

const AsmDashboard = () => {
  const navigate = useNavigate();

  // ASM dashboard data
  const asmName = "ASM Name";
  const asmId = "ASM1001";

  // Replace demo values with API data when available
  const totalSm = 0;
  const totalDealers = 0;

  const quickActions = [
    {
      title: "Add SM",
      description: "Add a new Sales Manager",
      path: "add-sm",
      icon: "👤",
    },
    {
      title: "Add Dealer",
      description: "Add a new dealer",
      path: "add-dealer",
      icon: "🏪",
    },
  ];

  const overviewCards = [
    {
      title: "Total SM",
      value: totalSm,
      icon: "👥",
    },
    {
      title: "Total Dealers",
      value: totalDealers,
      icon: "🏪",
    },
  ];

  return (
    <div className="container-fluid py-4">
      {/* Dashboard Header */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">ASM Dashboard</h2>
          <p className="text-muted mb-0">
            Welcome back! Here's your dashboard overview.
          </p>
        </div>

        <div className="mt-3 mt-md-0">
          <span className="badge bg-primary px-3 py-2">
            ASM Panel
          </span>
        </div>
      </div>

      {/* Overview */}
      <div className="row g-4 mb-4">
        {overviewCards.map((card, index) => (
          <div className="col-12 col-sm-6 col-xl-4" key={index}>
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-muted mb-2">{card.title}</p>
                    <h3 className="fw-bold mb-0">{card.value}</h3>
                  </div>

                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: "55px",
                      height: "55px",
                      backgroundColor: "#f0f4ff",
                      fontSize: "25px",
                    }}
                  >
                    {card.icon}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body p-4">
          <h5 className="fw-bold mb-1">Quick Actions</h5>
          <p className="text-muted mb-4">
            Quickly access your frequently used features.
          </p>

          <div className="row g-3">
            {quickActions.map((action, index) => (
              <div className="col-12 col-md-6" key={index}>
                <button
                  type="button"
                  onClick={() => navigate(action.path)}
                  className="btn border w-100 text-start p-3 h-100"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: "#f0f4ff",
                        fontSize: "23px",
                        flexShrink: 0,
                      }}
                    >
                      {action.icon}
                    </div>

                    <div>
                      <h6 className="fw-bold mb-1">{action.title}</h6>
                      <small className="text-muted">
                        {action.description}
                      </small>
                    </div>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ASM Information */}
      <div className="card border-0 shadow-sm">
        <div className="card-body p-4">
          <h5 className="fw-bold mb-3">Account Information</h5>

          <div className="row g-3">
            <div className="col-12 col-md-6">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <small className="text-muted d-block mb-1">
                  Logged-in ASM
                </small>
                <h6 className="fw-bold mb-0">{asmName}</h6>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <small className="text-muted d-block mb-1">
                  ASM ID
                </small>
                <h6 className="fw-bold mb-0">{asmId}</h6>
              </div>
            </div>

            <div className="col-12">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <small className="text-muted d-block mb-1">
                  Account Type
                </small>
                <h6 className="fw-bold mb-0">Area Sales Manager</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AsmDashboard;